import React from 'react';
import { AiOutlineTwitter } from "react-icons/ai";
import { BsLinkedin, BsGithub } from "react-icons/bs";
import { FaMediumM } from "react-icons/fa";
import { FiMail } from "react-icons/fi";

const Footer = () => {
    return (
        <footer className="w-full bg-[#040811] border-t border-slate-800/50 py-6 md:py-8 mt-6 md:mt-10">
            <div className='max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-4'>
                <div className='flex space-x-6 items-center'>
                    <a 
                        target="_blank" 
                        rel="noreferrer" 
                        href="https://twitter.com/Uticodes"
                        aria-label="Twitter Profile"
                        className="text-slate-400 hover:text-primary transition-colors hover:-translate-y-1 transform duration-300"
                    >
                        <AiOutlineTwitter size={24} />
                    </a>
                    <a 
                        target="_blank" 
                        rel="noreferrer" 
                        href="https://www.linkedin.com/in/utibe-etim-0a901a107/"
                        aria-label="LinkedIn Profile"
                        className="text-slate-400 hover:text-primary transition-colors hover:-translate-y-1 transform duration-300"
                    >
                        <BsLinkedin size={22} />
                    </a>
                    <a 
                        target="_blank" 
                        rel="noreferrer" 
                        href="https://github.com/Uticodes"
                        aria-label="GitHub Profile"
                        className="text-slate-400 hover:text-primary transition-colors hover:-translate-y-1 transform duration-300"
                    >
                        <BsGithub size={22} />
                    </a>
                    <a 
                        target="_blank" 
                        rel="noreferrer" 
                        href="https://medium.com/@utibeetim"
                        aria-label="Medium Profile"
                        className="text-slate-400 hover:text-primary transition-colors hover:-translate-y-1 transform duration-300"
                    >
                        <FaMediumM size={22} />
                    </a>
                    <a 
                        href="mailto:etim.utibe@gmail.com"
                        aria-label="Send Email"
                        className="text-slate-400 hover:text-primary transition-colors hover:-translate-y-1 transform duration-300"
                    >
                        <FiMail size={22} />
                    </a>
                </div>
                <div className='text-center md:text-right'>
                    <p className="text-slate-500 text-sm">
                        &copy; {new Date().getFullYear()} Utibe Etim. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
